import BulkAddMember from './BulkAddMember.component';

export default BulkAddMember;